<template>
  <div>
    <div
      v-if="!!value || defaultSlot"
      class="table_label"
      :class="{ primary: primary }"
    >
      <span>{{ text }}</span>
      <slot
        ><span>{{ value }}</span></slot
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: { type: String, default: '' },
    value: { type: [Number, String], default: '' },
    labelKey: { type: String, default: '' },
    primary: { type: Boolean, default: false },
  },
  computed: {
    text() {
      if (!this.labelKey) return this.label || ''
      return this.$l(this.labelKey) || ''
    },
    defaultSlot() {
      return !!this.$slots.default
    },
  },
}
</script>

<style lang="scss" scoped>
.table_label {
  span:empty {
    display: none;
  }
  span:first-child {
    color: #303133;
    &::after {
      content: '：';
    }
  }
}

.table_label.primary {
  span:last-child {
    color: #409eff;
  }
}
</style>
